import { styled } from "../theme";
export const FormSlide = styled.div `
  display: flex;
  flex-direction: column;
  flex: 3;
`;
